import React, { useContext } from "react";
import { Link } from "react-router-dom";
import TranslationsContext from "../../infrastructure/context/translations/translations-context";
import TranslationManager from "../../infrastructure/translation-manager";
import { TranslationKeys } from "../../infrastructure/const";

type PageHeaderLogoProps = {
  brand?: string;
  className?: string;
};

const PageHeaderLogo = (props: PageHeaderLogoProps): JSX.Element => {
  let logoSrc, logoAlt, logoTitle: string;

  const translationsContext = useContext(TranslationsContext);
  const translationManager = new TranslationManager(translationsContext);

  switch (props.brand) {
    case "phonicear":
      logoSrc = "/images/phonic-ear-logo.png";
      logoAlt = "Phonic Ear Logo";
      logoTitle = "Phonic Ear";
      break;
    case "bernafon":
      logoSrc = "/images/bernafon-logo.png";
      logoAlt = "Bernafon Logo";
      logoTitle = "Bernafon";
      break;
    case "horselbutik":
      logoSrc = "/images/horselbutik-logo.png";
      logoAlt = "Horselbutik Logo";
      logoTitle = "Horselbutik";
      break;
    default:
      logoSrc = "https://cdn.dgs.com/ecommerce/oticon_130px.svg";
      logoAlt = "Oticon Logo";
      logoTitle = "Oticon People First";
  }

  if (translationManager.getTranslation(TranslationKeys.LOGO_TITLE)) {
    logoTitle = translationManager.getTranslation(TranslationKeys.LOGO_TITLE);
  }

  return (
    <Link to="/" title={logoTitle} className={props.className || "logo"}>
      <img src={logoSrc} alt={logoAlt} />
    </Link>
  );
};

export default PageHeaderLogo;
